import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "./styles.scss"

const NumeroArchivosAdjuntos = ({ num }: $TSMigrationFixMe) => {
  if (!num) {
    return (
      <div className='numero_archivos_adjuntos__container archivosAdjuntos'>
        -
      </div>
    )
  }

  return (
    <div className='numero_archivos_adjuntos__container archivosAdjuntos'>
      <div>
        <FontAwesomeIcon
          icon={["fal", "paperclip"]}
          size='lg'
        />
        <span className='numero_archivos_adjuntos__badge archivosAdjuntos'>
          {num}
        </span>
      </div>
    </div>
  )
}

export default NumeroArchivosAdjuntos
